import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {ProviderServiceSummaryModel} from './providerServiceSummary.model';
import {ProviderServiceCoveringModel} from "./providerServiceCovering.model";

export class ProviderServiceModel implements WithSummaryModel<ProviderServiceSummaryModel> {
    summary: ProviderServiceSummaryModel;
    coverings: ProviderServiceCoveringModel[] = [];
}
